import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/style.css";

import imag1 from "./img/niclogo1.jpg";
import imag2 from "./img/customer-support-service-center-generative-ai (1).jpg";
import imag3 from "./img/working-office (2).jpg";
import imag5 from "./img/7044158 (2).jpg";
import imag6 from "./img/cover_3.jpg";
import demo1 from "./img/registration.jpg";
import demo2 from "./img/data Signing.jpg";
import demo3 from "./img/pdfsignature.jpg";
import demo4 from "./img/batchSigning.jpg";
import demo5 from "./img/xml_s (1).jpg";
import demo6 from "./img/digitalsignature.jpg";
import toggleBtn from "./img/toggleBtnCustom.svg";


import AOS from "aos";
import "aos/dist/aos.css";

// MUI Icon Imports
import StarIcon from "./img/star.svg";
import backIcon from "./img/back-arrow.svg";
import arrowsIcon from "./img/arrows.svg";
import bookmarkIcon from "./img/bookmark_white.svg";
import calenderIcon from "./img/calender_white.svg";
import codeIcon from "./img/code.svg";
import atdIcon from "./img/atd.svg";
import eyeIcon from "./img/preview.svg";
import folederIcon from "./img/folder_white.svg";
import hammerIcon from "./img/setting.svg";
import homeIcon from "./img/home.svg";
import laptop2Icon from "./img/laptop2.svg";
import laptop3Icon from "./img/lap_white.svg";
import laptop1Icon from "./img/laptop1.svg";
import layerIcon from "./img/layesr_white.svg";
import locationIcon from "./img/location.svg";
import notesIcon from "./img/notes.svg";
import pdfIcon from "./img/pdf.svg";
import phoneIcon from "./img/call.svg";
import serverIcon from "./img/server_white.svg";
import spannnerIcon from "./img/spanner_white.svg";
// import systemIcon from "./img/system.png";
import RequestFormMain from "../RequestFormMain";
import LoginPage from "../LoginPage";
import { baseUrl } from "../../Constnats/constants";
import { baseUrl1 } from "../../Constnats/constants1";
import { demoUrl } from "../../Constnats/constants2";
import Loader from "./Loader";

function LandingPage() {
  useEffect(() => {
    AOS.init();
  }, []);
  const scrollToTop = () => {
    var element = document.getElementById("detailMainWrapper");
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const [showRequestForm, setShowRequestForm] = useState(false);
  const handleClickBtn = () => {
    setShowRequestForm(true);
  };
  const [showAdmin, setShowAdmin] = useState(false);
  const handleAdmin = () => {
    window.location.href = baseUrl1 + "adminLogin";
  };
  useEffect(() => {
    scrollToTop();
  }, []);

  const baseUrlDwnld = `${baseUrl}/downloadzip`;
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (showAdmin) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [showAdmin]);
  const [activeSection, setActiveSection] = useState("home");

  const handleSelect = (url) => {
    setActiveSection(url);
    const element = document.getElementById(url);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const sections = ["home", "about", "features", "services", "demo"];
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    
    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        const { offsetTop, clientHeight } = element;
        if (scrollPosition >= offsetTop - clientHeight / 3 && scrollPosition < offsetTop + clientHeight / 3) {
          setActiveSection(section);
        }
      }
    });
  };
  return (
    <div>
      {showRequestForm ? (
        <RequestFormMain />
      ) : showAdmin ? (
        isLoading ? (
          <Loader />
        ) : (
          <LoginPage setShowAdmin={setShowAdmin} />
        )
      ) : (
        <div
          data-bs-spy="scroll"
          data-bs-target=".navbar"
          id="detailMainWrapper"
        >
          {/* Navbar */}
          <nav
            className="navbar fixed-top navbar-expand-lg navbar-light bg-white"
            data-aos="fade-down"
          >
            <div className="container">
              <div className="logowithHeading">
                <div>
                  <img src={imag1} alt="" />
                </div>
                <a className="navbar-brand" href="/">
                  NICDSign
                </a>
              </div>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"><img  src={toggleBtn} alt="togglebtn"/></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ms-auto">
                  {["home", "about", "features", "services", "demo"].map((item) => (
                    <li className="nav-item" key={item}>
                      <a 
                        className={activeSection === item ? 'nav-link activeBtn' : "nav-link"}
                        onClick={() => handleSelect(item)}
                      >
                        {item.charAt(0).toUpperCase() + item.slice(1)}
                      </a>
                    </li>
                  ))}
                  <li className="nav-item">
                    <a
                      className="nav-link topBtn mr addNewBtn"
                      onClick={() => handleSelect("download")}
                    >
                      Download Request for NICDSign Client
                    </a>
                  </li>
                  <li className="nav-item">
                    <button className="topBtn bord" onClick={handleClickBtn}>
                      Request for NICDSign
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          {/* Hero */}
          <section
            id="home"
            className="bg-cover hero-section"
          >
            <div className="overlay"></div>
            <div className="container text-white text-center">
              <div className="row">
                <div className="col-12">
                  <h1 className="display-4" data-aos="zoom-in">
                    Simplifying Digital Signing <br />
                    Across Platforms with NICDSign
                  </h1>
                  <p className="my-4" data-aos="fade-up">
                    The NICDSign is a cross-platform, browser independent
                    solution for digital signature using PKCS#11 tokens. <br />
                    The NICDSign is a client based solution where the DSC
                    capabilities are installed in the client machine as a
                    background service
                  </p>
                  <a
                    href="#services"
                    data-aos="fade-up"
                    className="btn btn-main"
                  >
                    Get started
                  </a>
                </div>
              </div>
            </div>
          </section>
          {/* Features */}
          <section id="features" className="text-center">
            <div className="container">
              <div className="row">
                <div
                  className="col-12 section-intro text-center"
                  data-aos="fade-up"
                >
                  <h1> Features</h1>
                  <div className="divider"></div>
                  <p className="justP">
                    A cross-platform, browser-independent server-side API for
                    signing data, PDF, and XML documents using PKCS#7, with
                    features like CRL checks, TSA integration,
                    <br />
                    automatic token detection, and batch signing. Supports major
                    operating systems and browsers, ensuring interoperability
                    and seamless integration with any application.
                  </p>
                </div>
              </div>
              <div className="row gx-4 gy-5 mainWrap">
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                   <img src={StarIcon} alt="star" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">Cross-Platform Compatibility</h5>
                  <p className="justP">
                    Supports all major client operating systems (Windows, Linux,
                    MacOS) and browsers (Chrome, Firefox, Internet Explorer,
                    Safari) without requiring plugins.
                  </p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={notesIcon} alt="notes" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">Comprehensive Document Signing</h5>
                  <p className="justP">
                    Capable of signing data, PDF, and XML documents using PKCS#7
                    Cryptographic Messaging Standard for interoperability.
                  </p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={laptop1Icon} alt="laptop" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">Server-Side API Service</h5>
                  <p className="justP">
                    Centralized API service for digital signing, easily
                    integrated with any application regardless of the
                    technology.
                  </p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={atdIcon} alt="atd" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">CRL and TSA Integration</h5>
                  <p className="justP">
                    Performs Certificate Revocation List checks and uses trusted
                    Time Stamping Authority for time stamping PDF documents.
                  </p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={codeIcon} alt="code" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">Automatic Token Detection</h5>
                  <p className="justP">
                    Supports auto-detection and configuration of digital
                    signature certificate tokens during signing attempts.
                  </p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={pdfIcon} alt="pdf" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">PDF Signature Features</h5>
                  <p className="justP">
                    Allows digital signature stamping, wet ink signature
                    placement on the last page or all pages, and uses server
                    time for signing.
                  </p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={eyeIcon} alt="eye" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">Content Preview</h5>
                  <p className="justP">
                    Provides the capability to view the PDF/XML content being
                    signed.
                  </p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={hammerIcon} alt="hammer" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">Batch Signing</h5>
                  <p className="justP">
                    Supports batch signing of PDF files, enabling the signing of
                    multiple documents in a single session.
                  </p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={backIcon} alt="star" style={{ height: '60px', width: '60px' }} />
                  </div>
                  <h5 className="mt-4 mb-3">Interoperability</h5>
                  <p className="justP">
                    Ensures generated signatures are interoperable across
                    various applications and platforms.
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* About */}
          <section
            id="about"
            className="bg-cover"
            style={{ backgroundImage: `url(${imag6})` }}
          >
            <div className="overlay"></div>
            <div className="container text-white text-center">
              <div className="row">
                <div
                  className="col-12 section-intro text-center"
                  data-aos="fade-up"
                >
                  <h1>About</h1>
                  <div className="divider"></div>
                  <p className="justP">
                    The NICDSign is a cross-platform, browser independent
                    solution for digital signature using PKCS#11 tokens. The
                    NICDSign is a client based solution where the DSC
                    capabilities are installed in the client machine as a
                    background service. The NICDSign solution overcomes the
                    problem of applet based DSC solutions due to the lack of
                    browser support. The support for applets is withdrawn from
                    major browsers and Oracle is planning to deprecate Java
                    browser plugins starting JDK9. The signing of data is
                    carried at the client side and the verification of signature
                    is carried out in the server side. The solution is also
                    cable of signing PDF files with visible signature stamping
                    in the document. NICDSign solution is supported in all the
                    major operating systems viz Windows, Linux and macOS. The
                    solution can be integrated by applications developed in
                    Java, PHP and .NET etc.
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* Services */}
          <section id="services" className="text-center">
            <div className="container">
              <div className="row">
                <div
                  className="col-12 section-intro text-center"
                  data-aos="fade-up"
                >
                  <h1> Services</h1>
                  <div className="divider"></div>
                  <p>
                    The DSC signer solution includes a client-side service for
                    DSC registration and signing, a jQuery-based
                    <br />
                    helper library for web applications, and a server-side API
                    for certificate verification and signature decryption.
                  </p>
                </div>
              </div>
              <div className="row g-4">
                <div className="col-md-4" data-aos="zoom-in">
                  <div className="service">
                    <div className="service-img">
                      <img src={imag2} alt="" />
                      <div className="icon">
                        <i className="material-icons"> <img src={laptop3Icon} style={{ height: '25px', width: '25px' }} alt="laptop"  /> </i>
                      </div>
                    </div>
                    <h5 className="mt-5 pt-4">Client-Side Service</h5>
                    <p className="justP">
                      A Java application on the end-user's machine facilitates
                      DSC registration and signing. It includes a background
                      service for USB device detection and a component providing
                      REST API access to PKCS#11 token stores for certificate
                      selection and signing.
                    </p>
                  </div>
                </div>
                <div className="col-md-4" data-aos="zoom-in">
                  <div className="service">
                    <div className="service-img">
                      <img src={imag3} alt="" />
                      <div className="icon">
                        <i className="material-icons"><img src={layerIcon} style={{ height: '25px', width: '25px' }} alt="layers"  /></i>
                      </div>
                    </div>
                    <h5 className="mt-5 pt-4">Client Helper Library</h5>
                    <p className="justP">
                      A jQuery-based library enabling developers to access
                      DSCSigner APIs from a web application running on the
                      client browser. It is used to implement DSC registration
                      and signing functionalities in web application pages.
                    </p>
                  </div>
                </div>
                <div className="col-md-4" data-aos="zoom-in">
                  <div className="service">
                    <div className="service-img">
                      <img src={imag5} alt="" />
                      <div className="icon">
                        <i className="material-icons"> <img src={serverIcon} style={{ height: '25px', width: '25px' }} alt="server"  /> </i>
                      </div>
                    </div>

                    <h5 className="mt-5 pt-4">Server-Side API</h5>
                    <p className="justP">
                      Provides server-side functionalities such as certificate
                      verification, signature content verification, and
                      decryption of signed PDF files. It offers a RESTful
                      interface, making it consumable by applications developed
                      on any platform.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* */}
          <section className="bg-cover counterbg">
            <div className="overlay"></div>
            <div className="container text-white text-center">
              <div className="row gy-4" data-aos="fade-up">
                <div className="col-md-3"><img src={calenderIcon} style={{ height: '30px', width: '30px' , color:'white' }} alt="calender"  /></div>
                <div className="col-md-3"><img src={bookmarkIcon} style={{ height: '30px', width: '30px', color:'white' }} alt="calender"  /></div>
                <div className="col-md-3"><img src={folederIcon} style={{ height: '30px', width: '30px',color:'white' }} alt="folder"  /></div>
                <div className="col-md-3"><img src={spannnerIcon} style={{ height: '30px', width: '30px',color:'white' }} alt="build"  /></div>
              </div>
            </div>
          </section>
          {/* Demo */}

          <section id="demo" className="bg-light">
            <div className="container">
              <div className="row">
                <div
                  className="col-12 section-intro text-center"
                  data-aos="fade-up"
                >
                  <h1>NICDSign Demo</h1>
                  <div className="divider"></div>
                  <p>
                    NICDSign provides PKCS#11 token based DSC signing and
                    verification capabilities to clients. Facility to verify
                    various capabilities of NICDSign can be viewed by clicking
                    the appropriate options under NICDSign Demo. NICDSign client
                    may be downloaded and configured for checking the demo.
                  </p>
                </div>
              </div>
              <div className="row text-start">
                <div className="col-md-4 paddb image_ht" data-aos="fade-up">
                  <img src={demo1} alt="" />
                  <div className="mt-4">
                    <div className="demoBtn">
                      <a
                        className="demoBtnWrap"
                        href={demoUrl + "RegisterDSC.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                    </div>
                    <h5 className="mt-1 mb-2">
                      <a href="/">DSC Registration</a>
                    </h5>
                    <p>DSC Registration Demo.</p>
                  </div>
                </div>
                <div className="col-md-4 paddb image_ht" data-aos="fade-up">
                  <img src={demo2} alt="" />
                  <div className="mt-4">
                    <div className="demoBtn">
                      <a
                        className="demoBtnWrap"
                        href={demoUrl + "SignDataRegCert.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                    </div>
                    <h5 className="mt-1 mb-2">
                      <a href="/">Data Signing</a>
                    </h5>
                    <p>Data Signing to generate detached pkcs#7 signature.</p>
                  </div>
                </div>

                <div className="col-md-4 paddb image_ht" data-aos="fade-up">
                  <img src={demo3} alt="" />
                  <div className="mt-4">
                    <div className="demoBtn">
                      <a
                        className="demoBtnWrap"
                        href={demoUrl + "SignPdfStamping.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                    </div>
                    <h5 className="mt-1 mb-2">
                      <a href="/">Pdf Signing : Wet ink signature stamping</a>
                    </h5>
                    <p>
                      Stamping Mode Pdf Signing. Allow stamping on all pages or
                      last page
                    </p>
                  </div>
                </div>
                <div className="col-md-4 image_ht" data-aos="fade-up">
                  <img src={demo4} alt="" />
                  <div className="mt-4">
                    <div className="demoBtn">
                      <a
                        className="demoBtnWrap spcl"
                        href={demoUrl + "XMLBatchTest.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo (XML) <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                      <a
                        className="demoBtnWrap spcl"
                        href={demoUrl + "PDFBatchTest.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo (PDF) <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                    </div>
                    <h5 className="mt-1 mb-2">
                      <a href="/">Batch XML/PDF Signing</a>
                    </h5>
                    <p>
                      Create a batch with a predefined size and sign XML/PDF files
                      continuously with only one time PIN prompt
                    </p>
                  </div>
                </div>
                <div className="col-md-4 image_ht" data-aos="fade-up">
                  <img src={demo5} alt="" />
                  <div className="mt-4">
                    <div className="demoBtn">
                      <a
                        className="demoBtnWrap"
                        href={demoUrl + "SignXMLRegCert.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                    </div>
                    <h5 className="mt-1 mb-2">
                      <a href="/">XML Signing</a>
                    </h5>
                    <p>Signing of XML Data</p>
                  </div>
                </div>
                <div className="col-md-4 image_ht" data-aos="fade-up">
                  <img src={demo6} alt="" />
                  <div className="mt-4">
                    <div className="demoBtn">
                      <a
                        className="demoBtnWrap spcl"
                        href={demoUrl + "SignPdfNoStampingRegCert.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                      <a
                        className="demoBtnWrap spcl"
                        href={demoUrl + "SignPdfNoStampingV2.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo <br />(Self Sign) <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                      <a
                        className="demoBtnWrap spcl"
                        href={demoUrl + "SignPdfNoStampingV3.html"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Demo <br />(custom page sign) <img src={arrowsIcon} style={{ height: '15px', width: '15px' }} alt="arrow" />
                      </a>
                    </div>
                    <h5 className="mt-1 mb-2">
                      <a href="/">Pdf Signing : Digital Signature Stamping</a>
                    </h5>
                    <p>Non Stamping mode Pdf Signing.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* */}
          <section id="download" className="text-center">
            <div className="container">
              <div className="row">
                <div
                  className="col-12 section-intro text-center"
                  data-aos="fade-up"
                >
                  <h1>Download Request for NICDSign Client</h1>
                  <div className="divider"></div>
                  <p className="justP"></p>
                </div>
              </div>
              <div className="row gx-4 gy-5 mainWrap">
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={laptop2Icon} style={{ height: '60px', width: '60px' }}  alt="laptop"  />
                  </div>
                  <a className="topBtn mr" href={`${baseUrlDwnld}/exe`}>
                    Download for Windows
                  </a>
                  <h5 className="mt-4 mb-3">Download for Windows</h5>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={laptop2Icon} style={{ height: '60px', width: '60px' }}  alt="laptop"  />
                  </div>
                  <a href={`${baseUrlDwnld}/ubuntu`} className="topBtn mr">
                    Download for Ubuntu
                  </a>
                  <h5 className="mt-4 mb-3">Download for Ubuntu</h5>
                  <p className="justP"></p>
                </div>
                <div className="col-md-4 feature subWrap" data-aos="fade-up">
                  <div className="icon">
                    <img src={laptop2Icon} style={{ height: '60px', width: '60px' }}  alt="laptop"  />
                  </div>
                  <a className="topBtn mr" href={`${baseUrlDwnld}/macos`}>
                    Download for MacOS
                  </a>
                  <h5 className="mt-4 mb-3">Download for MacOs</h5>
                  <p className="justP"></p>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}

          <footer className="py-4">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <p className="mb-0">
                    Copyright © 2024 Designed, Developed and Hosted by National
                    Informatics Centre
                  </p>
                </div>
                <div className="col-md-6 text-md-end">
                  <div>
                    <a href="https://www.google.com/maps/dir//CDAC+Buildings,+Keltron+Compund,+Manaveeyam+Road,+Nandavanam,+Vellayambalam,+Thiruvananthapuram,+Kerala+695033/@8.5171271,76.897726,19z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3b05bbcb7f1f59c9:0x5982c5d590d2fc90!2m2!1d76.9613927!2d8.5100611?entry=ttu">
                      <img src={locationIcon} style={{ height: '30px', width: '30px' }}  alt="location"  />
                    </a>
                    <a href="https://kerala.nic.in/contact-us/">
                      <img src={phoneIcon} style={{ height: '30px', width: '30px' }} alt="phone"  />
                    </a>
                    <a href="#home">
                      <img src={homeIcon} style={{ height: '30px', width: '30px' }} alt="home"  />
                    </a>
                    <button className=" adminLogin" onClick={handleAdmin}>
                      Admin Login
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      )}
    </div>
  );
}

export default LandingPage;